import { Product } from '@commercetools/frontend-domain-types/product/Product';
import ProductSlider, { ProductSliderProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/product/product-slider';
import usePermissionsChecker from 'helpers/hooks/usePermissionsChecker';
import { TasticWithCMS } from 'types/tastic';
import { SustainabilityItem } from 'components/commercetools-ui/types';

export interface DataCmsProps {
  fields: SustainabilityItem;
}

function ProductSliderTastic({
  data,
  customerGroup,
}: TasticWithCMS<{ items: Product[] }, ProductSliderProps, DataCmsProps>) {
  const { getFields, checkItemPermission } = usePermissionsChecker();

  if (!data?.data?.dataSource?.items?.length) return <></>;

  //eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { mobile, tablet, desktop, ...props } = data;

  const getSustainability = (data: any, customerGroup: any) => {
    const certificationsItem = data?.cmsDataCertifications?.dataSource?.items?.find(
      (item: DataCmsProps) => item?.fields?.icons?.length,
    );
    const environmentalItem = data?.cmsDataEnvironmental?.dataSource?.items?.find(
      (item: DataCmsProps) => item?.fields?.icons?.length,
    );

    const fieldsCertificationsItem =
      certificationsItem && checkItemPermission(certificationsItem, customerGroup)
        ? getFields(certificationsItem)
        : undefined;

    const fieldsEnvironmentalItem =
      environmentalItem && checkItemPermission(environmentalItem, customerGroup)
        ? getFields(environmentalItem)
        : undefined;

    return {
      certificationsItem: fieldsCertificationsItem,
      environmentalItem: fieldsEnvironmentalItem,
    };
  };

  const sustainability = getSustainability(data, customerGroup);

  return <ProductSlider {...props} products={data.data.dataSource.items} sustainability={sustainability} />;
}

export default ProductSliderTastic;
